
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { HomeService } from '../../core/services/home.service';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../../core/services/toast.service';
import { SEOService } from '../../core/seo.service';

@Component({
  selector: 'app-career-apply',
  templateUrl: './career-apply.component.html',
  styleUrls: ['./career-apply.component.scss'],
})
export class CareerApplyComponent implements OnInit {
  careerForm!: FormGroup;
  emailRegex = new RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  phoneRegex = new RegExp(/^[6-9]\d{9}$/);
  jobTypes = {
    frontend: 'Angular JS | React JS | Sencha ExtJS | JQuery |BackBone JS',
    backend: 'Java | PHP | Ruby On Rails | Node.JS | C#.Net',
    database: 'MySQL | Postgre SQL | MS SQL Server | Oracle | MongoDB',
    cloud: 'AWS | AZURE | Google Cloud | Jenkins/Git Labs',
  };
  allowedFileMimeTypes = [
    {
      mimeType: 'text/plain',
      extension: 'txt',
    },
    {
      mimeType: 'application/msword',
      extension: 'doc',
    },
    {
      mimeType: 'audio/mpeg',
      extension: 'mp3',
    },
    {
      mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessing',
      extension: 'docx',
    },
    { mimeType: 'application/vnd.ms-excel', extension: 'xls' },
    {
      mimeType:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      extension: 'xlsx',
    },
    {
      mimeType: 'application/vnd.ms-powerpoint',
      extension: 'ppt',
    },
    {
      mimeType:
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      extension: 'pptx',
    },
    {
      mimeType: 'application/pdf',
      extension: 'pdf',
    },
  ];
  constructor(
    private _fb: FormBuilder,
    private toast: ToastService,
    private service: HomeService,
    private acr: ActivatedRoute,
    // private seoService: SEOService,
  ) {}

  ngOnInit(): void {
    this.careerForm = this._fb.group({
      name: [null, [Validators.required]],
      phoneNo: [
        null,
        [Validators.required, Validators.pattern(this.phoneRegex)],
      ],
      email: [null, [Validators.required, Validators.pattern(this.emailRegex)]],
      experience: [null, [Validators.required]],
      file: [null, [Validators.required]],
    });
    // this.setSeo();
  }

  async submitQuotationForm(): Promise<void> {
    if (this.careerForm.invalid) {
      this.toast.openSnackBar('Enter Valid Form');
      this.careerForm.markAllAsTouched();
      return;
    }
    const carrierFormDetails = this.careerForm.value;
    if(this.acr.snapshot.paramMap.get('job') !== null) {
      carrierFormDetails.job = this.jobTypes[this.acr.snapshot.paramMap.get('job')];
    }

    const res = await this.service.carrierForm(carrierFormDetails);
    if (res) {
      this.careerForm.reset();
    }
  }

  get name() {
    return this.careerForm.get('name');
  }
  get file() {
    return this.careerForm.get('file');
  }
  get email() {
    return this.careerForm.get('email');
  }
  get phoneNo() {
    return this.careerForm.get('phoneNo');
  }
  get experience() {
    return this.careerForm.get('experience');
  }
  
  // setSeo(): void {
  //   this.seoService.updatePageTitle('database | Rapinno Tech');
  //   this.seoService.updateOgTitle('database | Rapinno Tech');
  //   this.seoService.updateOgDescription('Rapinnotech is committed to helping our clients be their best. We love to learn & grow fulfilling not only ours but also the organizational goals as well. If you are interested in joining a team that will push you to redefine your full potential, check out our job openings below and join us!');
  //   this.seoService.updateOgType('database Page');
  //   this.seoService.updateOgUrl('https://www.rapinnotech.com/database');
  //   this.seoService.updateMetaTitle('database | Rapinno Tech'),
  //   this.seoService.updateMetaDescription('Rapinnotech is committed to helping our clients be their best. We love to learn & grow fulfilling not only ours but also the organizational goals as well. If you are interested in joining a team that will push you to redefine your full potential, check out our job openings below and join us!')
  // }
}
